export const menuData = [
  {
    category: 'Queijo',
    items: [
      {
        id: '01',
        name: 'Cheddar',
        desc: 'Queijo cheddar, bacon, champignon e mussarela.',
        prices: ['67,00', '69,00', '71,00', '79,00'],
      },
      {
        id: '02',
        name: 'Dois Queijos',
        desc: 'Mussarela e catupiry.',
        promo: true,
        prices: ['46,00', '48,00', '50,00', '58,00'],
      },
      {
        id: '03',
        name: 'Italiana',
        desc: 'Mussarela, champignon, tomate, pimentão e cebola.',
        prices: ['66,00', '68,00', '70,00', '78,00'],
      },
      {
        id: '04',
        name: 'Três Queijos',
        desc: 'Mussarela, catupiry e provolone.',
        prices: ['63,00', '65,00', '67,00', '75,00'],
      },
      {
        id: '05',
        name: 'Quatro Queijos',
        desc: 'Mussarela, catupiry, parmesão e provolone.',
        prices: ['65,00', '67,00', '69,00', '77,00'],
      },
      {
        id: '06',
        name: 'Cinco Queijos',
        desc: 'Mussarela, catupiry, gorgonzola, parmesão e provolone.',
        prices: ['67,00', '69,00', '71,00', '79,00'],
      },
      {
        id: '07',
        name: 'Seis Queijos',
        desc: 'Mussarela, parmesão, provolone, catupiry, cheddar e gorgonzola.',
        prices: ['68,00', '70,00', '72,00', '80,00'],
      },
      {
        id: '08',
        name: 'Grega',
        desc: 'Mussarela, champignon, catupiry, e provolone.',
        prices: ['67,00', '69,00', '71,00', '79,00'],
      },
      {
        id: '09',
        name: 'Mussarela',
        desc: 'Mussarela e tomate.',
        promo: true,
        prices: ['46,00', '48,00', '50,00', '58,00'],
      },
      {
        id: '10',
        name: 'Mussarela Crocante',
        desc: 'Mussarela, catupiry e batata palha.',
        prices: ['64,00', '66,00', '68,00', '76,00'],
      },
      {
        id: '11',
        name: 'Margherita',
        desc: 'Mussarela, tomate, parmesão e manjericão.',
        prices: ['61,00', '63,00', '65,00', '73,00'],
      },
    ],
  },
  {
    category: 'Calabresa',
    items: [
      {
        id: '12',
        name: 'Baiacatu',
        desc: 'Calabresa moída, catupiry e mussarela.',
        promo: true,
        prices: ['46,00', '48,00', '50,00', '58,00'],
      },
      {
        id: '13',
        name: 'Baiana',
        desc: 'Calabresa apimentada, ovo, cebola, mussarela e manjericão.',
        prices: ['61,00', '63,00', '65,00', '73,00'],
      },
      {
        id: '14',
        name: 'Calabresa',
        desc: 'Calabresa, cebola e mussarela.',
        promo: true,
        prices: ['46,00', '48,00', '50,00', '58,00'],
      },
      {
        id: '15',
        name: 'Toscana',
        desc: 'Calabresa moída, catupiry e parmesão.',
        prices: ['63,00', '65,00', '67,00', '75,00'],
      },
      {
        id: '16',
        name: 'Toscana Especial',
        desc:
          'Calabresa moída, mussarela, catupiry, parmesão, decorada com pimentões coloridos refogados com cebola.',
        prices: ['67,00', '69,00', '71,00', '79,00'],
      },
    ],
  },
  {
    category: 'Aves',
    items: [
      {
        id: '17',
        name: 'Adventista',
        desc: 'Peito de peru, palmito, catupiry, mussarela, ervilha e ovo.',
        prices: ['67,00', '69,00', '71,00', '79,00'],
      },
      {
        id: '18',
        name: 'Caipira',
        desc: 'Frango desfiado, catupiry, milho, mussarela e tomate.',
        prices: ['67,00', '69,00', '71,00', '79,00'],
      },
      {
        id: '19',
        name: 'Frango',
        desc: 'Frango desfiado, catupiry, bacon e mussarela.',
        prices: ['66,00', '68,00', '70,00', '78,00'],
      },
      {
        id: '20',
        name: 'Frango Crocante',
        desc: 'Frango desfiado, catupiry, batata palha e mussarela.',
        prices: ['68,00', '70,00', '72,00', '80,00'],
      },
      {
        id: '21',
        name: 'Itália',
        desc:
          'Frango desfiado, catupiry, milho, palmito, ervilha, champignon e mussarela.',
        prices: ['70,00', '72,00', '74,00', '82,00'],
      },
      {
        id: '22',
        name: 'Frango Cream Cheese',
        desc: 'Frango desfiado, mussarela e cream cheese.',
        prices: ['68,00', '70,00', '72,00', '80,00'],
      },
      {
        id: '23',
        name: 'Peito de Peru',
        desc: 'Peito de Peru, mussarela, catupiry e tomate.',
        prices: ['66,00', '68,00', '70,00', '78,00'],
      },
      {
        id: '24',
        name: 'Peito de Peru Especial',
        desc: 'Peito de peru, cream cheese e mussarela.',
        prices: ['67,00', '69,00', '71,00', '79,00'],
      },
      {
        id: '25',
        name: 'Piracicabana',
        desc: 'Frango desfiado, cheddar, mussarela e bacon.',
        prices: ['66,00', '68,00', '70,00', '78,00'],
      },
      {
        id: '26',
        name: 'Requinte',
        desc:
          'Frango desfiado, palmito, presunto, bacon, ervilha, catupiry e mussarela.',
        prices: ['70,00', '72,00', '74,00', '82,00'],
      },
      {
        id: '27',
        name: 'Tropical',
        desc:
          'Frango desfiado, mussarela, brócolis, palmito, champignon e creme de leite.',
        prices: ['70,00', '72,00', '74,00', '82,00'],
      },
      {
        id: '28',
        name: 'Veneza',
        desc:
          'Frango desfiado, palmito, champignon, catupiry, mussarela e parmesão.',
        prices: ['68,00', '70,00', '72,00', '80,00'],
      },
    ],
  },
  {
    category: 'Lombo Canadense',
    items: [
      {
        id: '29',
        name: 'À Moda da Casa',
        desc: 'Lombo, palmito, bacon, mussarela e parmesão.',
        prices: ['68,00', '70,00', '72,00', '80,00'],
      },
      {
        id: '30',
        name: 'Brasileira',
        desc: 'Lombo, ovo, ervilha, milho e mussarela.',
        prices: ['64,00', '66,00', '68,00', '76,00'],
      },
      {
        id: '31',
        name: 'Lombo',
        desc: 'Lombo, catupiry e mussarela.',
        prices: ['62,00', '64,00', '66,00', '74,00'],
      },
      {
        id: '32',
        name: 'Lombo Especial',
        desc: 'Lombo, cebola, cheddar e mussarela.',
        prices: ['65,00', '67,00', '69,00', '77,00'],
      },
    ],
  },
  {
    category: 'Presunto',
    items: [
      {
        id: '33',
        name: 'Americana',
        desc: 'Presunto, ervilha e mussarela.',
        promo: true,
        prices: ['46,00', '48,00', '50,00', '58,00'],
      },
      {
        id: '34',
        name: 'À Moda do Pizzaiolo',
        desc: 'Presunto, milho, ervilha, palmito e mussarela.',
        prices: ['65,00', '67,00', '69,00', '77,00'],
      },
      {
        id: '35',
        name: 'Da Hora',
        desc: 'Presunto, champignon, catupiry, bacon e mussarela.',
        prices: ['65,00', '67,00', '69,00', '77,00'],
      },
      {
        id: '36',
        name: 'Forneiro',
        desc: 'Presunto, azeitonas verdes picadas, mussarela e catupiry.',
        prices: ['63,00', '64,00', '66,00', '74,00'],
      },
      {
        id: '37',
        name: 'Francesa',
        desc: 'Presunto, ovos, catupiry, mussarela e manjericão.',
        prices: ['68,00', '70,00', '72,00', '80,00'],
      },
      {
        id: '38',
        name: 'Francesa Especial',
        desc:
          'Presunto, ovo, palmito, cebola, bacon, tomate, catupiry, mussarela, pimenta e manjericão.',
        prices: ['70,00', '72,00', '74,00', '82,00'],
      },
      {
        id: '39',
        name: 'Napoli',
        desc: 'Presunto, mussarela, catupiry, tomate e parmesão.',
        prices: ['63,00', '65,00', '67,00', '75,00'],
      },
      {
        id: '40',
        name: 'Napolitana',
        desc: 'Presunto, mussarela, tomate e manjericão.',
        promo: true,
        prices: ['46,00', '48,00', '50,00', '58,00'],
      },
      {
        id: '41',
        name: 'Portuguesa',
        desc:
          'Presunto, catupiry, ervilha, milho, palmito, bacon, ovo, cebola em mussarela.',
        prices: ['70,00', '72,00', '74,00', '82,00'],
      },
      {
        id: '42',
        name: 'Presunto',
        desc: 'Presunto, mussarela e tomate.',
        promo: true,
        prices: ['46,00', '48,00', '50,00', '58,00'],
      },
      {
        id: '43',
        name: 'Portuguesinha',
        desc: 'Presunto, ovo, cebola, ervilha, palmito e mussarela.',
        prices: ['65,00', '67,00', '69,00', '77,00'],
      },
    ],
  },
  {
    category: 'Verduras',
    items: [
      {
        id: '44',
        name: 'Brócolis',
        desc: 'Brócolis, catupiry, bacon e mussarela.',
        prices: ['65,00', '67,00', '69,00', '77,00'],
      },
      {
        id: '45',
        name: 'Escarola',
        desc: 'Escarola, catupiry, bacon e mussarela.',
        promo: true,
        prices: ['46,00', '48,00', '50,00', '58,00'],
      },
      {
        id: '46',
        name: 'Escarola com Aliche',
        desc: 'Escarola, aliche, provolone e mussarela.',
        prices: ['66,00', '68,00', '70,00', '78,00'],
      },
      {
        id: '47',
        name: 'havaiana',
        desc: 'Brócolis, escarola, bacon, catupiry e provolone.',
        prices: ['66,00', '68,00', '70,00', '78,00'],
      },
      {
        id: '48',
        name: 'Naturitália',
        desc: 'Brócolis, bacon, palmito, catupiry, mussarela e tomate seco.',
        prices: ['68,00', '70,00', '72,00', '80,00'],
      },
      {
        id: '49',
        name: 'Rúcula',
        desc: 'Peito de peru, mussarela, tomate seco e rúcula fresca.',
        prices: ['65,00', '67,00', '69,00', '77,00'],
      },
      {
        id: '50',
        name: 'Vegetariana',
        desc: 'Escarola, tomate seco, brócolis, champignon e mussarela.',
        prices: ['66,00', '68,00', '70,00', '78,00'],
      },
      {
        id: '51',
        name: 'Verona',
        desc: 'Brócolis, palmito, creme de leite, mussarela e tomate seco.',
        prices: ['69,00', '71,00', '73,00', '81,00'],
      },
      {
        id: '52',
        name: 'Vegana',
        desc: 'Escarola, palmito, brócolis, tomate, champignon e abobrinha.',
        prices: ['68,00', '70,00', '72,00', '80,00'],
      },
    ],
  },
  {
    category: 'Palmito',
    items: [
      {
        id: '53',
        name: 'Alemã',
        desc: 'Palmito, milho, catupiry, mussarela e batata palha.',
        prices: ['66,00', '68,00', '70,00', '78,00'],
      },
      {
        id: '54',
        name: 'Alpina',
        desc: 'Palmito, mussarela, bacon e provolone.',
        prices: ['65,00', '67,00', '69,00', '77,00'],
      },
      {
        id: '55',
        name: 'Palmito',
        desc: 'Palmito, tomate, catupiry e mussarela.',
        prices: ['66,00', '68,00', '70,00', '78,00'],
      },
      {
        id: '56',
        name: 'Praiana',
        desc:
          'Palmito, champignon, mussarela, parmesão, ovo, cebola e ervilha.',
        prices: ['67,00', '69,00', '71,00', '79,00'],
      },
      {
        id: '57',
        name: 'Primavera',
        desc: 'Palmito, mussarela, milho, ovo, presunto e cebola.',
        prices: ['69,00', '71,00', '73,00', '81,00'],
      },
    ],
  },
  {
    category: 'Milho',
    items: [
      {
        id: '58',
        name: 'Milho',
        desc: 'Milho, catupiry e mussarela.',
        promo: true,
        prices: ['46,00', '48,00', '50,00', '58,00'],
      },
      {
        id: '59',
        name: 'Sertaneja',
        desc: 'Milho, palmito e mussarela.',
        prices: ['62,00', '64,00', '66,00', '74,00'],
      },
      {
        id: '60',
        name: 'Paulista',
        desc: 'Milho, ervilha, ovo e mussarela.',
        promo: true,
        prices: ['46,00', '48,00', '50,00', '58,00'],
      },
      {
        id: '61',
        name: 'Corn & Bacon',
        desc: 'Milho, bacon, catupiry e mussarela.',
        prices: ['64,00', '66,00', '68,00', '76,00'],
      },
    ],
  },
  {
    category: 'Variedades',
    items: [
      {
        id: '62',
        name: 'Alho',
        desc: 'Alho crocante, mussarela e tomate.',
        promo: true,
        prices: ['46,00', '48,00', '50,00', '58,00'],
      },
      {
        id: '63',
        name: 'Do Papa',
        desc: 'Catupiry, tomate, parmesão salpicado com alho frito.',
        prices: ['65,00', '67,00', '69,00', '77,00'],
      },
      {
        id: '64',
        name: 'Peperone',
        desc: 'Salame tipo peperone, catupiry e mussarela.',
        prices: ['68,00', '70,00', '71,00', '80,00'],
      },
      {
        id: '65',
        name: 'Carne Seca',
        desc: 'Carne seca refogada, catupiry e mussarela.',
        prices: ['77,00', '79,00', '81,00', '89,00'],
      },
      {
        id: '66',
        name: 'Abobrinha',
        desc: 'Abobrinha, mussarela, catupiry e parmesão.',
        prices: ['65,00', '67,00', '69,00', '77,00'],
      },
      {
        id: '67',
        name: 'Filé Mignon',
        desc: 'Filé mignon em tiras, catupiry e mussarela.',
        prices: ['85,00', '87,00', '89,00', '97,00'],
      },
      {
        id: '68',
        name: 'Filé Migon com Rúcula',
        desc: 'Filé migon em tiras, rúcula e mussarela.',
        prices: ['85,00', '87,00', '89,00', '97,00'],
      },
      {
        id: '69',
        name: 'Filé Mignon com Barbecue',
        desc: 'Filé mignon em tiras, barbecue e mussarela.',
        prices: ['87,00', '89,00', '91,00', '99,00'],
      },
      {
        id: '70',
        name: 'Strogonof de Frango',
        desc: 'Strogonof de frango, mussarela e batata palha.',
        prices: ['79,00', '81,00', '83,00', '91,00'],
      },
      {
        id: '71',
        name: 'Strogonof de Mignon',
        desc: 'Strogonof de carne, mussarela e batata palha.',
        prices: ['88,00', '90,00', '92,00', '100,00'],
      },
    ],
  },
  {
    category: 'Peixes',
    items: [
      {
        id: '72',
        name: 'Aliche',
        desc: 'Filé de anchovas, mussarela, tomate e provolone.',
        prices: ['64,00', '66,00', '68,00', '76,00'],
      },
      {
        id: '73',
        name: 'Atum',
        desc: 'Atum, catupiry, cebola e mussarela.',
        prices: ['66,00', '68,00', '70,00', '78,00'],
      },
      {
        id: '74',
        name: 'Atum Especial',
        desc:
          'Atum, mussarela, catupiry, decorada com pimentões refogados com cebola.',
        prices: ['68,00', '70,00', '72,00', '80,00'],
      },
      {
        id: '75',
        name: 'Camarão',
        desc: 'Camarão refogado, mussarela e tomate.',
        prices: ['74,00', '76,00', '78,00', '86,00'],
      },
      {
        id: '76',
        name: 'Chefe',
        desc: 'Atum, ervilha, palmito e mussarela.',
        prices: ['66,00', '68,00', '70,00', '78,00'],
      },
      {
        id: '77',
        name: 'Peruana',
        desc:
          'Mussarela, palmito, atum, ovos, cebola e azeitonas verdes picadas.',
        prices: ['69,00', '71,00', '73,00', '81,00'],
      },
    ],
  },
  {
    category: 'Bacon',
    items: [
      {
        id: '78',
        name: 'Bacon',
        desc: 'Bacon, catupiry e mussarela.',
        prices: ['61,00', '63,00', '65,00', '73,00'],
      },
      {
        id: '79',
        name: 'Romana',
        desc: 'Bacon, mussarela e cebola.',
        prices: ['61,00', '63,00', '65,00', '73,00'],
      },
      {
        id: '80',
        name: 'Siciliana',
        desc: 'Bacon, presunto, mussarela e manjericão.',
        prices: ['63,00', '65,00', '67,00', '75,00'],
      },
      {
        id: '81',
        name: 'Siciliana 2',
        desc: 'Bacon, champignon, cebola, presunto, catupiry e mussarela.',
        prices: ['66,00', '68,00', '70,00', '78,00'],
      },
    ],
  },
  {
    category: 'Novidades',
    items: [
      {
        id: '82',
        name: 'Shitake',
        desc: 'Mussarela, shitake, shimeji, cebola, tomate e parmesão.',
        prices: ['82,00', '84,00', '86,00', '94,00'],
      },
      {
        id: '83',
        name: 'Abóbora com Carne',
        desc: 'Carne seca, purê de abóbora, catupiry e mussarela.',
        prices: ['82,00', '84,00', '86,00', '94,00'],
      },
      {
        id: '84',
        name: 'Alho Poró',
        desc: 'Mussarela, alho poró e cream cheese.',
        prices: ['66,00', '68,00', '70,00', '78,00'],
      },
      {
        id: '85',
        name: 'Frango c/ Alho Poró',
        desc: 'Frango desfiado, mussarela, alho poró, cream cheese.',
        prices: ['82,00', '84,00', '86,00', '94,00'],
      },
      {
        id: '86',
        name: 'Peito de Peru c/ Alho Poró',
        desc: 'Peito de peru, mussarela, cream cheese e alho poró.',
        prices: ['82,00', '84,00', '86,00', '94,00'],
      },
    ],
  },
];

export const pizzasDocesData = [
  {
    category: 'Pizzas Doces',
    items: [
      {
        id: '88',
        name: 'Banana',
        desc: 'Banana, açucar e canela.',
        promo: true,
        prices: ['46,00', '48,00', '50,00', '58,00'],
      },
      {
        id: '89',
        name: 'Banana com Chocolate',
        desc: 'Chocolate Nestlé coberto com banana.',
        prices: ['69,00', '71,00', '73,00', '81,00'],
      },
      {
        id: '90',
        name: 'Banana Nevada',
        desc: 'Banana fatiada coberta com chocolate branco gratinado',
        prices: ['71,00', '73,00', '75,00', '83,00'],
      },
      {
        id: '91',
        name: 'Beijinho',
        desc: 'Massa de beijinho, leite condensado e coco.',
        promo: true,
        prices: ['46,00', '48,00', '50,00', '58,00'],
      },
      {
        id: '92',
        name: 'Brigadeiro',
        desc: 'Chocolate Nestlé, brigadeiro e granulado.',
        prices: ['66,00', '68,00', '70,00', '78,00'],
      },
      {
        id: '93',
        name: 'Califórnia',
        desc:
          'Lombo canadense, abacaxi, figo, ameixa, pêssego salpicada com mussarela.',
        prices: ['69,00', '71,00', '73,00', '81,00'],
      },
      {
        id: '94',
        name: 'Churros',
        desc: 'Doce de leite com canela e açúcar.',
        promo: true,
        prices: ['46,00', '48,00', '50,00', '58,00'],
      },
      {
        id: '95',
        name: 'Doce de Leite',
        desc: 'Doce de leite com coco.',
        promo: true,
        prices: ['46,00', '48,00', '50,00', '58,00'],
      },
      {
        id: '96',
        name: 'Kids',
        desc: 'Chocolate Nestlé coberto com confetes.',
        prices: ['69,00', '71,00', '73,00', '81,00'],
      },
      {
        id: '97',
        name: 'Leite Ninho',
        desc: 'Creme de leite Ninho decorado com creme de avelã.',
        prices: ['71,00', '73,00', '75,00', '83,00'],
      },
      {
        id: '98',
        name: 'Merengue',
        desc: 'Chocolate branco, morango e suspiro.',
        prices: ['68,00', '70,00', '72,00', '80,00'],
      },
      {
        id: '99',
        name: 'Oreo',
        desc: 'Chocolate branco coberto com biscoito Oreo.',
        prices: ['69,00', '71,00', '73,00', '81,00'],
      },
      {
        id: '100',
        name: 'Ouro Branco',
        desc: 'Chocolate Nestlé coberto com bombons Ouro Branco.',
        prices: ['69,00', '71,00', '73,00', '81,00'],
      },
      {
        id: '101',
        name: 'Prestígio',
        desc: 'Chocolate Nestlé, coco ralado e cereja.',
        prices: ['66,00', '68,00', '70,00', '78,00'],
      },
      {
        id: '102',
        name: 'Romeu e Julieta',
        desc: 'Mussarela e goiabada.',
        promo: true,
        prices: ['46,00', '48,00', '50,00', '58,00'],
      },
      {
        id: '103',
        name: 'Sensação',
        desc: 'Creme de avelã coberto com morangos.',
        prices: ['71,00', '73,00', '75,00', '83,00'],
      },
      {
        id: '104',
        name: 'Sonho de Valsa',
        desc: 'Chocolate Nestlé coberto com bombons Sonho de Valsa.',
        prices: ['69,00', '71,00', '73,00', '81,00'],
      },
    ],
  },
];
